<template>
  <button
    class="tw-text-sky-50 tw-bg-sky-700 tw-rounded tw-py-2 tw-px-4 hover:tw-shadow-lg hover:tw-shadow-sky-100 hover:tw-bg-sky-600 tw-transition-all disabled:tw-opacity-30 disabled:tw-grayscale disabled:tw-pointer-events-none"
  >
    <slot />
  </button>
</template>
<script setup lang="ts"></script>
<style scoped></style>
